/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var GridType;
(function (GridType) {
    GridType[GridType["DASHBOARD"] = 0] = "DASHBOARD";
    GridType[GridType["REPORT"] = 1] = "REPORT";
    GridType[GridType["SIMULATION"] = 2] = "SIMULATION";
})(GridType || (GridType = {}));
export function GridTypeFromJSON(json) {
    return GridTypeFromJSONTyped(json, false);
}
export function GridTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function GridTypeToJSON(value) {
    return value;
}
